define('forms',['controller', 'lib/bootstrap-maxlength'], function(controller, _) {
	controller.on(function() {
	    $('input[maxlength]').maxlength({
	        alwaysShow: false,
	        threshold: 10,
	        warningClass: "label-info",
	        limitReachedClass: "label-info",
	        placement: 'top',
	        preText: '',
	        separator: ' von ',
	        postText: ' Zeichen übrig',
            showCharsTyped: false
	    });
	});
});

